module.exports = __webpack_public_path__ + "img/enabled.e812f1af.svg";